import { currencyOptions } from "@/common/const";
import {
  eplAccessTechOptions,
  includedOptions,
} from "@/common/const/filter-options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const eplFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "text",
    label: "Country",
    name: "country",
    required: true,
  },
  {
    inputType: "text",
    label: "Last Mile Provider",
    name: "lastMileProvider",
    required: true,
  },
  {
    inputType: "text",
    label: "Vendor Product Name",
    name: "vendorProductName",
    required: true,
  },
  {
    inputType: "text",
    label: "Cable Provider",
    name: "cableProvider",
    required: true,
  },
  {
    inputType: "text",
    label: "Bandwidth (in Mbps)",
    name: "bandWidth",
    required: true,
    patternMessage: "Value not satisfied range from 0.128 to 10,000",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
  },
  {
    label: "Currency",
    name: "currency",
    readonly: false,
    required: false,
    inputType: "select",
    options: currencyOptions,
  },
  {
    inputType: "text",
    label: "OTE",
    name: "OTE",
    required: true,
  },
  {
    inputType: "text",
    label: "MRE",
    name: "MRE",
    required: true,
  },
  {
    inputType: "select",
    label: "Local Tax/VAT*",
    name: "isLocalTax",
    required: true,
    options: includedOptions,
  },
  {
    inputType: "text",
    label: "Local Tax/VAT (in %)",
    name: "localTax",
    required: true,
  },
  {
    inputType: "select",
    label: "Access Technology",
    name: "AccessTechnology",
    required: true,
    options: eplAccessTechOptions,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: true,
  },
  {
    inputType: "text",
    label: "SLA Uptime (in %)",
    name: "SlaUptime",
    required: true,
  },
  {
    inputType: "text",
    label: "SLA MTTR (in Hours)",
    name: "SlaMTTR",
    required: true,
  },
  {
    inputType: "text",
    label: "SLA Latency (in ms)",
    name: "slaLatency",
    required: true,
  },
  {
    inputType: "select",
    label: "Jumbo Frames",
    name: "jumboFrames",
    required: true,
    options: [
      {
        label: "Yes",
        value: "Yes",
      },
      {
        label: "No",
        value: "No",
      },
    ],
  },
  {
    inputType: "text",
    label: "MTU Size (in Bytes)",
    name: "mtuSize",
    required: true,
  },
  {
    inputType: "select",
    label: "QinQ Supported",
    name: "qinqSupported",
    required: true,
    options: [
      {
        label: "Yes",
        value: "Yes",
      },
      {
        label: "No",
        value: "No",
      },
    ],
  },
  {
    label: "Price code",
    name: "priceCode",
    required: false,
    inputType: "text",
  },
];

export default eplFormStrategy;
